import React, { createContext, useContext } from 'react';

const detectElectron = () =>
  typeof window !== 'undefined' &&
  window.process &&
  window.process.type === 'renderer';

export const ElectronContext = createContext(false);

export const useElectron = () => useContext(ElectronContext);

export const ElectronProvider = ({ children }) => {
  const isElectron = detectElectron();

  return (
    <ElectronContext.Provider value={isElectron}>
      {children}
    </ElectronContext.Provider>
  );
};
